import HTTP from "./http";
import Vue from "vue";

function additionalHeaders() {
  let fbp = "";
  let fbc = "";

  try {
    if (document.cookie.includes("_fbp"))
      fbp = document.cookie.split("_fbp=")[1].split(";")[0];
    if (document.cookie.includes("_fbc"))
      fbc = document.cookie.split("_fbc=")[1].split(";")[0];
  } catch (e) {}

  return {
    headers: {
      "X-Session-Client-Cookie": `${fbc}|${fbp}`
    }
  };
}

export default {
  async authenticate(creds) {
    try {
      creds.email = creds.email.toLowerCase();
      const config = {
        ...additionalHeaders()
      };
      return await HTTP.withAccept.post("/authentication", creds, config);
    } catch (e) {
      throw e;
    }
  },
  async authenticateOldAPI(creds) {
    try {
      let res = await Vue.http.post(
        "https://api.donamaid.com/api/authenticate",
        creds,
        {
          emulateJSON: true
        }
      );

      if (!res.body.success) throw "Usuário ou senha incorretos!";

      return res.body.data;
    } catch (e) {
      throw e;
    }
  },
  async checkToken() {
    const config = {
      ...additionalHeaders()
    };
    try {
      return await HTTP.withAccept.get("/token-check", config);
    } catch (e) {
      throw e;
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/authentication.js